import { Link } from "react-router-dom";
import { create } from "zustand";
import { useProjects } from "./hooks";
import type { ProjectNextActionGap } from "./types";

interface ProjectHintState {
  /** Projekt, który właśnie stracił ostatnie next action. */
  hint: ProjectNextActionGap | null;
  /** Projekt do rozwinięcia po wejściu w zakładkę Projekty. */
  openProjectId: string | null;
  show: (gap: ProjectNextActionGap) => void;
  dismiss: () => void;
  openProject: (id: string | null) => void;
}

/** Stan tylko w pamięci: wskazówka dotyczy tego, co użytkownik właśnie odhaczył. */
export const useProjectHint = create<ProjectHintState>()((set) => ({
  hint: null,
  openProjectId: null,
  show: (gap) => set({ hint: gap }),
  dismiss: () => set({ hint: null }),
  openProject: (id) => set({ openProjectId: id }),
}));

/** Pasek nad listami po odhaczeniu ostatniego next poza szufladą projektu. */
export function ProjectNextHint() {
  const hint = useProjectHint((s) => s.hint);
  return hint ? <ProjectNextHintBanner hint={hint} /> : null;
}

function ProjectNextHintBanner({ hint }: { hint: ProjectNextActionGap }) {
  const dismiss = useProjectHint((s) => s.dismiss);
  const openProject = useProjectHint((s) => s.openProject);
  const { data } = useProjects();

  // Lista jest świeża po każdej zmianie (też z czatu): gdy projekt dostał krok
  // albo został zamknięty, wskazówka nie ma już czego pilnować.
  const view = data?.find((v) => v.project.id === hint.id);
  if (data && !view?.stalled) return null;

  return (
    <div className="hint" role="status">
      <span>
        Projekt „{hint.title}” nie ma już następnego kroku. Dopisz kolejny albo zamknij projekt.
      </span>
      <span className="hint__actions">
        <Link
          className="btn btn--small"
          to="projekty"
          onClick={() => {
            openProject(hint.id);
            dismiss();
          }}
        >
          Otwórz projekt
        </Link>
        <button className="btn btn--small" onClick={dismiss} aria-label="Zamknij wskazówkę">
          ✕
        </button>
      </span>
    </div>
  );
}
